export const HAS_SEEN_WELCOME_DIALOG = 'CRM:Settings:Pipelines:HasViewedCardFrameworkWelcomeDialog';
export const getUserSettingDefaultValues = () => ({
  [HAS_SEEN_WELCOME_DIALOG]: 'true'
});